import { Injectable } from '@angular/core';
import firebase from 'firebase';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from 'src/app/core/auth/auth.service';
import { rejects } from 'assert';
import { FirestoreRulesService } from 'src/app/core/firestore-rules/firestore-rules.service';
import { LocalStorageService } from 'src/app/core/local-storage/local-storage.service';
import { LocalStorageKeys } from 'src/app/core/local-storage/local-storage.enum';
import { combineLatest, from, Observable } from 'rxjs';
import { IUser, IUserMetadata } from '../interfaces/user.interface';
import { map, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { UserAdminVerificationStatusEnum, UserValuesData } from '../interfaces/user-values';
import { LocaleEnum } from 'src/app/submit-lecture/lecture.values';
import { ILecture } from 'src/app/views/pages/lectures/lecture.interface';

export const COMPLETION_SCORE = 100;

@Injectable({
  providedIn: 'root'
})
export class UserScoreService {


  constructor() {
  }

  getClosureScore(progress: any): number {

    return progress.numberOfLectures * COMPLETION_SCORE;
  }
}
